var generateComponentTheme = function generateComponentTheme(_ref) {
  var spacing = _ref.spacing,
    borders = _ref.borders,
    colors = _ref.colors;
  return {
    borderWidth: borders.widthMedium,
    borderColor: colors.porcelain,
    categoryDescriptionBackground: colors.porcelain,
    categoriesWrapperPadding: spacing.xSmall,
    categoriesContainerPadding: spacing.xSmall,
    categoryContainerWrapperPadding: spacing.xSmall,
    categoryDescriptionInputPadding: spacing.xSmall,
    categoryBodyAnswersPadding: spacing.xSmall,
    itemContainerPadding: spacing.xSmall,
    itemContainerBodyPadding: spacing.xxSmall
  };
};
export default generateComponentTheme;